module.exports = __webpack_public_path__ + "img/bg_tc_zp.90665b5b.png";